import React, { useState } from 'react'
import { connect } from 'react-redux'
import { RootState } from '../../redux/store'
import styles from './authorForm.module.scss'
import { addAuthor } from '../../redux/author.slice'
import { CreateAuthor } from '../../types/author'

interface AuthorFormProps {
  addAuthor: (author: CreateAuthor) => void
}

const AuthorForm = ({ addAuthor }: AuthorFormProps) => {
  const [nameEng, setNameEng] = useState<string>('')
  const [nameEsp, setNameEsp] = useState<string>('')
  const [biographyEng, setBiographyEng] = useState<string>('')
  const [biographyEsp, setBiographyEsp] = useState<string>('')
  const [image, setImage] = useState<string>()

  const addAuthorHandler = () => {
    if (nameEng && nameEsp && biographyEng && biographyEsp && image) {
      const newAuthor: CreateAuthor = {
        name: {
          eng: nameEng,
          esp: nameEsp,
        },
        biography: {
          eng: biographyEng,
          esp: biographyEsp,
        },
        image: image!,
      }
      addAuthor(newAuthor)
      setNameEng('')
      setNameEsp('')
      setBiographyEng('')
      setBiographyEsp('')
      setImage('')
    }
  }

  return (
    <div className={styles.root}>
      <span className={styles.formTitle}>Add Author</span>
      <input
        value={nameEng}
        className={styles.textInput}
        onChange={(e) => setNameEng(e.target.value)}
        type="text"
        name=""
        id=""
        placeholder="name in english"
      />
      <input
        value={nameEsp}
        className={styles.textInput}
        onChange={(e) => setNameEsp(e.target.value)}
        type="text"
        name=""
        id=""
        placeholder="name in spanish"
      />
      <textarea
        value={biographyEng}
        className={styles.textArea}
        onChange={(e) => setBiographyEng(e.target.value)}
        name=""
        id=""
        rows={5}
        placeholder="information in english"
      />
      <textarea
        value={biographyEsp}
        className={styles.textArea}
        onChange={(e) => setBiographyEsp(e.target.value)}
        name=""
        id=""
        rows={5}
        placeholder="name in spanish"
      />
      <input
        value={image}
        className={styles.textInput}
        onChange={(e) => setImage(e.target.value)}
        type="text"
        name=""
        id=""
        placeholder="image url"
      />
      <input
        onClick={addAuthorHandler}
        type="button"
        value="Add author"
        className={styles.button}
      />
    </div>
  )
}

const mapStateToProps = (stat: RootState) => ({})

export default connect(mapStateToProps, { addAuthor })(AuthorForm)
